/**
 * Pressable that primes web audio and plays a short tap SFX (respects Game sounds mute).
 * Set playTapSound={false} when the parent already plays a specific SFX (e.g. dialog confirm/dismiss).
 */

import React, { forwardRef } from 'react';
import { Pressable as RNPressable, type PressableProps } from 'react-native';
import { soundService } from '../../services/SoundService';
import { useSoundStore } from '../../stores/soundStore';
import { SOUND_IDS, type SoundId } from '../../constants/sounds.constants';

export type SoundPressableProps = PressableProps & {
  /** When false, only warms audio — no tap clip (avoids double sound with dialog/snackbar SFX). Default true. */
  playTapSound?: boolean;
  /** Which short tap SFX to play (`SoundService` maps native CDN + web synth per id). Default generic `UI_TAP`. */
  tapSoundId?: SoundId;
};

export const SoundPressable = forwardRef<React.ElementRef<typeof RNPressable>, SoundPressableProps>(
  function SoundPressable(props, ref) {
    const { onPressIn, playTapSound = true, tapSoundId = SOUND_IDS.UI_TAP, ...rest } = props;
    return (
      <RNPressable
        ref={ref}
        {...rest}
        onPressIn={(e) => {
          soundService.warmWebAudioContextSync();
          void soundService.warmFromUserGesture();
          if (playTapSound) {
            useSoundStore.getState().playUiTapBrief(tapSoundId);
          }
          onPressIn?.(e);
        }}
      />
    );
  }
);
